import React, { useState, useEffect } from "react";
import "./Eeshan.css";
import Yogesh_Image from "../assets/Yogesh_Image.png";
import BoloLogo from "../assets/BoloLogo.svg";
import YoutubeIcon from "../assets/Youtube_Icon.svg";
import InstagramIcon from "../assets/Instagram_Icon.svg";
import LinkedInIcon from "../assets/LinkedIn_Icon.svg";
import XIcon from "../assets/X_Icon.svg";
import FacebookIcon from "../assets/Facebook_Icon.svg";
import API_CONFIG from "../API_Config/API_Config";
import Header from "../Header/Header";

const Yogesh = () => {
  const [show, setShow] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      if (window.scrollY > 0) {
        setShow(true);
      } else {
        setShow(false);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const links = [
    { name: "Youtube", url: API_CONFIG.YOUTUBE_LINK, icon: YoutubeIcon },
    { name: "Instagram", url: API_CONFIG.INSTAGRAM_LINK, icon: InstagramIcon },
    { name: "LinkedIn", url: API_CONFIG.LINKEDIN_LINK, icon: LinkedInIcon },
    { name: "X", url: API_CONFIG.TWITTER_LINK, icon: XIcon },
    { name: "Facebook", url: API_CONFIG.FACEBOOK_LINK, icon: FacebookIcon },
  ];

  return (
    <div className="Main_Mario_Page">
      {/* ── Header ── */}
      <Header />

      {/* ── Mario Page ── */}
      <div className="mario-page">
        {/* Mario Profile Card */}
        <div className="mario-card">
          <div className="Mario_Card_Main">
            <div className="Mario_Card_Left">
              <img
                src={Yogesh_Image}
                alt="Yogesh NR"
                className="mario-avatar"
              />
            </div>
            <div className="mario-info">
              <h2 className="mario-name">Yogesh NR</h2>
              <p className="mario-title">Content & Production Head</p>
            </div>
          </div>
        </div>
        <div className="mario-wrapper-mobile">
          <div className="mario-card-mobile">
            <div className="Mario_Content_Main">
              <h2 className="mario-title-mobile">
                Stay tuned with India on Bolo India
              </h2>
              <p className="mario-subtitle-mobile">
                connect with us and be part of the conversation!
              </p>
              <h2 className="mario-title-desktop">
                Stay tuned with India
                <br /> on Bolo India
              </h2>
              <p className="mario-subtitle-desktop">
                connect with us and be part
                <br /> of the conversation!
              </p>
            </div>
            <div className="mario-list-mobile">
              {links.map((item, index) => (
                <div key={index} className="mario-list-item-mobile">
                  <a
                    href={item.url}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="mario-link-mobile"
                  >
                    <img
                      src={item.icon}
                      alt={item.name}
                      className="mario-icon-mobile"
                    />
                    {item.name}
                  </a>
                </div>
              ))}
            </div>
          </div>
        </div>{" "}
      </div>
    </div>
  );
};

export default Yogesh;
